import {useSelector} from 'Provider';
import React from 'react';

import OfferPropertiesList from 'components/Offers/Filters/PropertiesList';
import {OfferFiltersProperty} from 'models/OfferFilters';
import {propertiesOfferCount} from 'store/offers/offers.selectors';

interface ConnectedOfferPropertiesListProps {
  properties: OfferFiltersProperty[];
  selected: OfferFiltersProperty[];
  onSelect: (item: OfferFiltersProperty) => void;
  onSelectAll: () => void;
  availableProperties?: string[];
}

const ConnectedOfferPropertiesList: React.FC<
  ConnectedOfferPropertiesListProps
> = ({properties, selected, onSelect, onSelectAll, availableProperties}) => {
  const pOfferCount = useSelector(propertiesOfferCount);

  return (
    <OfferPropertiesList
      properties={properties}
      selected={selected}
      onSelect={onSelect}
      onSelectAll={onSelectAll}
      availableProperties={availableProperties}
      propertiesOfferCount={pOfferCount}
    />
  );
};

export default ConnectedOfferPropertiesList;
